const navbar = () => {
  $(() => {
    $("body").on("click", ".menu-item .material-symbols-outlined", function () {
      $(this).next(".dropdown-menu").toggleClass("d-none");
    });

    if ($(window).width() >= 992) {
      $("body").on("mouseenter", ".dropdown", function () {
        $(this).find(".dropdown-menu").removeClass("d-none");
      });
      $("body").on("mouseleave", ".dropdown", function (e) {
        if (!$(e.relatedTarget).closest(".dropdown-menu").length) {
          $(this).find(".dropdown-menu").addClass("d-none");
        }
      });
    }

    const navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler) {
      navbarToggler.addEventListener("click", () => {
        navbarToggler.classList.toggle("collapsed");
        $("#navbarToggler").toggleClass("aperto");
        $("body").toggleClass("noscroll");
      });
    }

    $("body").on("click", ".lang__btn", function (e) {
      e.stopPropagation();
      $(this).closest(".lang__section").find(".lang__list").toggleClass("aperta");
    });

    $(document).on("click", function () {
      $(".lang__list").removeClass("aperta");
    });

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      var scroll = $(window).scrollTop();
      var header_top = $(".header-top").outerHeight();

      if (scroll > header_top) {
        $("body").addClass("stickyHeader");
      } else {
        $("body").removeClass("stickyHeader");
      }

      if ($(window).width() > 992) {
        if (scroll > lastScroll && scroll > 50) {
          $("body").addClass("scrollDown");
        } else {
          $("body").removeClass("scrollDown");
        }
      } else {
        $("body").removeClass("scrollDown");
      }

      lastScroll = scroll <= 0 ? 0 : scroll;
    });
  });
};

export default navbar;
